<template>
  <span>
    <span
      v-if="expert.terms_signed_at"
      class="badge bg-success badge-1rem expert-terms-signed-at"
      data-bs-toggle="tooltip"
      :title="tooltipText"
    > T&amp;C:
      {{ formatDate(expert.terms_signed_at) }} </span>
    <span
      v-else
      class="badge bg-danger badge-1rem expert-terms-signed-at"
      data-bs-toggle="tooltip"
      :title="tooltipText"
    > T&amp;C: N </span>

    <expert-terms-reminder-button
      v-if="showExpertBtn && (currentRouteName === 'backend.expert.index' || currentRouteName === 'backend.project.details' || currentRouteName === 'backend.expert.view')"
      :expert="expert" 
      :project-title="projectTitle"
    />
  </span>
</template>

<script>
import mixin from "../../../mixins/mixin";

export default {
  name: 'ExpertTermsConditionBadge',
  mixins: [mixin],
  props: {
    projectTitle: {
      type: String,
      default: ''
    },
    expert: {
      type: Object,
      required: true
    },
    showExpertBtn: {
      type: Boolean,
      default: true
    },
    currentRouteName: {
      type: String,
      required: false,
      default() {
        return "";
      }
    }
  },
  computed: {
    tooltipText() {
      if (this.expert.terms_signed_at) {
        return this.expert.ip_address 
          ? `IP Address: ${this.expert.ip_address}` 
          : 'IP Address: Not recorded';
      } else {
        return ''; // Return empty string if terms not signed, so no tooltip appears
      }
    }
  }
}
</script>